var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f7a41d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.865 48.489l-5.817 7.11-2.908-4.525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.865 48.489l-4.201 3.554-1.616 3.555H7.11v16.48h2.909l-3.555 1.617-2.585 5.493H0v-30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.018 72.079l-6.14 7.11-2.585-3.556zm8.078-23.59l1.94 4.524-8.08 2.585z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.096 48.489H35.87v7.11H11.957l6.14-3.879z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.485 72.079l-6.14 7.11-2.261-4.202z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.485 72.079l-5.17 2.908-.97 4.201H13.573v-7.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.473 41.38l-31.67 37.808L.97 86.621l31.67-38.132zM45.564 48.489l-.323 5.817-5.817 1.615z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.442 48.489v30.7H34.254l4.524-3.879 1.616-3.231h1.939V55.92h-2.909l3.232-2.908 2.908-4.524z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.394 72.079l1.616 4.847-7.756 2.262z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.02 48.489v4.847l-10.018.97H57.198v-5.817z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.02 53.336L66.891 73.371v1.293H56.875l17.127-20.358v-.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.342 73.371v5.817H56.875v-4.524l9.694-1.293zm3.555-24.882h7.11v30.7h-7.11zm39.424 14.541v12.603h-5.816v-8.078L116.335 64l-4.525-.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.334 63.354l5.17 4.2-9.694-4.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.321 75.633c-3.296 2.36-7.755 3.878-12.182 3.878-9.372 0-16.513-6.721-16.513-15.608 0-8.822 7.27-15.543 16.803-15.543 4.621 0 9.436 1.777 12.571 4.524l-4.201 4.847c-2.294-2.036-5.429-3.232-8.37-3.232-5.493 0-9.759 4.17-9.759 9.533 0 5.43 4.298 9.566 9.792 9.566 1.842 0 4.136-.744 6.14-1.778z"
  })));
};